export default __webpack_public_path__ + "static/media/03_Srnec_obecny_Kratochvil_cmmj_thumb-min.944564af.jpg";